import gql from 'graphql-tag';

export const FACEBOOK_IMPORT_REQUEST_CONFIRMATION_QUERY = gql`
  query FacebookImportRequestConfirmationQuery($requestId: Int!) {
    facebookImportRequestConfirmation(requestId: $requestId) {
      article {
        id
        title
        campaignId
        campaign {
          flipperFeatures {
            name
            enabled
          }
        }
      }
      creativesSize
      facebookAdsSize
      validationErrors
      importRequest {
        optOutFromRunner
        optOutFromCampaignReuse
        requestedBy {
          email
        }
      }
      importedCampaign {
        facebookCampaignId
        name
        objective
        status
        dailyBudget
        lifetimeBudget
        facebookCboEnabled
      }
      importedAdSet {
        facebookAdsetId
        name
        optimizationGoal
        effectiveStatus
        startTime
        endTime
        serializedTargeting
        targetingsentencelines {
          content
          children
        }
        dailyBudget
        lifetimeBudget
      }
      importedAds {
        facebookAdId
        name
        effectiveStatus
      }
    }
  }
`;
